/**
 * Created by olga on 19.01.2026
 */

const DialogueViewHorizontal = cc.Node.extend({
    ctor: function (dialogue, window) {
        this._super();
        this.dialogue = dialogue;
        this.window = window;

        this.autoScroll = dialogue.autoScroll;
        this.personSlots = [undefined, undefined];
        this.shown = false;

        this.setAnchorPoint(0, 0.5);
        this.setLocalZOrder(1);

        this.generateContent();
        this.onResize();
    },

    screenClicked: function () {
        if (!this.shown) {
            return;
        }

        if (this.typing) {
            this.finishTyping();
            return;
        }
        this.dialogue.next();
    },

    generateContent: function () {
        const content = this.content = new cc.Node();
        content.setAnchorPoint(0, 0);
        content.setCascadeOpacityEnabled(true);

        const background = this.background = cleverapps.UI.createScale9Sprite(bundles.dialogues.frames.bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setAnchorPoint(0, 0);
        background.setCascadeOpacityEnabled(true);
        content.addChild(background);

        const dialogueContent = this.dialogueContent = new cc.Node();
        dialogueContent.avoidNode = "DialogueView";
        dialogueContent.setVisible(false);
        dialogueContent.setAnchorPoint(0, 0);
        dialogueContent.addChild(content);

        this.addChild(dialogueContent);
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const styles = cleverapps.styles.DialogueViewHorizontal;

        this.setContentSize(sceneSize);

        const x = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? 0 : styles.widthPadding;
        this.content.setContentSize2(sceneSize.width - 2 * x, styles.size[cleverapps.resolution.mode].height);
        this.dialogueContent.setContentSize2(sceneSize.width, this.content.height);
        const safePadding = cleverapps.resolution.getSafePadding();
        this.background.setContentSize2(this.content.width, this.content.height + safePadding.bottom);
        this.background.baseContentSize = this.background.getContentSize();

        this.setAlignment(styles.position);

        this.content.stopAllActions();
        this.content.setOpacity(255);
        this.content.setAlignment(x, styles.offsetY);
        this.background.setAlignment({ align: "left" }, { align: "top" });

        [this.leftPersonView, this.rightPersonView].filter(Boolean).forEach((person) => {
            person.stopAllActions();
            person.setVisible(true);
            this.updatePersonSize(person);
            this.updatePersonPosition(person);
        });

        this.updateImagePosition();

        if (this.text) {
            this.text.onResize();
        }
    },

    onChangeStage: function (stageData) {
        const styles = cleverapps.styles.DialogueViewHorizontal;

        this.stageData = stageData;
        const active = stageData.person && Person.ParseOptions(stageData.person);
        if (active) {
            active.active = true;
        }
        const inactive = stageData.person2 && Person.ParseOptions(stageData.person2);
        if (inactive) {
            inactive.active = false;
        }

        let persons;

        if (active.orientation === "left") {
            persons = [active, inactive];
        } else {
            persons = [inactive, active];
        }

        persons.forEach(function (person, index) {
            const oldPerson = this.personSlots[index];
            if (!this.areSamePersons(person, oldPerson)) {
                if (oldPerson) {
                    this.hidePerson(oldPerson.orientation);
                }
                if (person) {
                    this.addPerson(person, this.dialogue.stage === 0);
                }
            } else {
                const personView = [this.leftPersonView, this.rightPersonView][index];
                if (personView) {
                    personView.setAnimation(0, person.emotion, true);
                }
            }
        }, this);
        this.hideImage();
        this.updateActive(active && active.orientation);

        if (stageData.image && !styles.noStageImage) {
            this.addImage(stageData.image);
        }

        this.personSlots = persons;

        if (this.window.shown) {
            this.onTyping();
        }
    },

    restoreState: function () {
        this.shown = true;
        this.resetPersonSlots();
        this.dialogueContent.setVisible(true);
        this.onChangeStage(this.dialogue.stageData);
        this.onResize();
    },

    onTyping: function (active) {
        this.typing = true;
        this.changeText(Messages.get(this.stageData.text), active);
    },

    areSamePersons: function unction(person1, person2) {
        return person1 && person2 && person1.orientation === person2.orientation
            && person1.role === person2.role;
    },

    resetPersonSlots: function () {
        this.personSlots = [undefined, undefined];
    },

    finishTyping: function (skipped) {
        this.typing = false;
        this.byLetterAnimationFinish(skipped);

        if (this.autoScroll) {
            this.dialogue.next(this.autoScroll);
        }
    },

    addPerson: function (person, silent) {
        const role = Person.ParseOptions(person).role;
        if (!cleverapps.persons.getRole(role)) {
            cleverapps.throwAsync(`Person is undefined - ${role}`);
            return;
        }

        const personView = new Person(person);
        personView.setAnimation(0, person.emotion, true);
        personView.setAnchorPoint(0.5, 0);
        personView.setActive(person.active);

        const personTitle = new DialoguePersonTitleView(person);
        personView.title = personTitle;

        const personArrow = new cc.Sprite(bundles.dialogues.frames.dialogue_arrow_png);
        personArrow.setVisible(false);
        personView.arrow = personArrow;

        if (personView.getOrientation() === "left") {
            this.leftPersonView = personView;
        } else {
            this.rightPersonView = personView;

            personArrow.setScaleX(-1);
        }

        this.content.addChild(personView);
        this.content.addChild(personArrow);
        this.content.addChild(personTitle);

        this.updatePersonSize(personView);
        this.updatePersonPosition(personView);

        addCleaner(personView, () => {
            personTitle.removeFromParent();
            personArrow.removeFromParent();

            if (this.leftPersonView === personView) {
                this.leftPersonView = undefined;
            }
            if (this.rightPersonView === personView) {
                this.rightPersonView = undefined;
            }
        });

        if (silent) {
            return;
        }

        const fromBelow = cleverapps.styles.DialogueViewHorizontal.showAnimation === "fromBelow";

        personView.setVisible(false);
        if (fromBelow) {
            personView.setPosition(personView.showPosition.x, -personView.showPosition.y - personView.height);
            personView.runAction(new cc.Sequence(
                new cc.DelayTime(0.15),
                new cc.Show(),
                new cc.MoveTo(0.45, personView.showPosition).easing(cc.easeBackOut(1)),
                new cc.CallFunc(() => {
                    cleverapps.scenes.onAvoidNodeVisibilityChanged();
                })
            ));
        } else {
            personView.runAction(new cc.Sequence(
                new cc.DelayTime(0.3),
                new cc.CallFunc(() => {
                    personView.setPosition(personView.hidePosition);
                }),
                new cc.Show(),
                new cc.MoveTo(0.25, personView.showPosition).easing(cc.easeBackOut())
            ));
        }
    },

    hidePerson: function (position) {
        const personView = position === "right" ? this.rightPersonView : this.leftPersonView;

        if (personView) {
            const fromBelow = cleverapps.styles.DialogueViewHorizontal.showAnimation === "fromBelow";
            personView.runAction(new cc.Sequence(
                fromBelow
                    ? new cc.MoveTo(0.225, personView.x, -personView.y - personView.height).easing(cc.easeBackIn(0.6))
                    : new cc.MoveTo(0.25, personView.hidePosition).easing(cc.easeIn(5)),
                new cc.RemoveSelf()
            ));

            personView.title.hide();
            personView.arrow.setVisible(false);
        }

        if (position === "right") {
            this.rightPersonView = undefined;
        } else {
            this.leftPersonView = undefined;
        }
        cleverapps.scenes.onAvoidNodeVisibilityChanged();
    },

    updatePersonSize: function (person) {
        const scale = this.getPersonScale(person);
        person.setScale(scale.x, scale.y);
    },

    getPersonScale: function (person) {
        const styles = cleverapps.styles.DialogueViewHorizontal.persons;
        let scale = 1;
        if (cleverapps.resolution.mode !== cleverapps.WideMode.HORIZONTAL) {
            scale = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? styles.mobileScale : styles.squareScale;
        }

        let scaleX = scale;
        if (person.getOrientation() !== "left") {
            scaleX = -scaleX;
        }

        return {
            x: scaleX, y: scale
        };
    },

    updatePersonPosition: function (person) {
        const styles = cleverapps.styles.DialogueViewHorizontal;

        const scale = Math.abs(person.getScaleX());
        const x = styles.persons[person.getOrientation()][cleverapps.resolution.mode].x;
        const y = this.content.height + styles.persons.offsetY * scale;

        person.setAlignment(x, y);

        const center = cc.p(this.width / 2, y);
        const personBox = person.getBoundingBox();

        if (cc.rectContainsPoint(personBox, center)) {
            const dx = styles.persons.margin / 2 + person.width / 2 * scale;
            person.setAlignment(
                person.getOrientation() === "left" ? center.x - dx : center.x + dx,
                y
            );
        }

        const personTitle = person.title;
        personTitle.setAlignment(person.x, cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? styles.title.mobileY : styles.title.y);

        const titleBox = personTitle.getBoundingBox();
        const offsetX = styles.title.offsetX;
        if (titleBox.x < offsetX || titleBox.x + titleBox.width > personTitle.parent.width - offsetX) {
            personTitle.setAlignment(
                person.getOrientation() === "left" ? { align: "left", dx: offsetX } : { align: "right", dx: -offsetX },
                personTitle.y
            );
        }

        const personAnchorBone = person.getBone("person_anchor");
        if (personAnchorBone) {
            const dX = (personAnchorBone.x || 0) * resolutionScale * person.getScaleX();
            const dY = (person.height / 2 + personAnchorBone.y * resolutionScale) * person.getScaleY();
            person.setPosition(personTitle.x - dX, personTitle.y - dY);
        }

        const position = person.getPosition();
        person.showPosition = position;
        person.hidePosition = cc.p(
            person.getOrientation() === "left" ? -person.width - this.content.x : this.content.x + this.content.width + person.width,
            position.y
        );

        const personArrow = person.arrow;
        const finalPersonBox = person.getBoundingBox();

        personArrow.setAlignment(
            person.getOrientation() === "left"
                ? Math.max(finalPersonBox.x + finalPersonBox.width, titleBox.x + titleBox.width) + personArrow.width / 2
                : Math.min(finalPersonBox.x, titleBox.x) - personArrow.width / 2,
            styles.arrow.y
        );
    },

    showUp: function (silent) {
        const onShow = () => {
            this.shown = true;
            this.onTyping();
        };
        const animationStyle = cleverapps.styles.DialogueViewHorizontal.showAnimation;
        if (silent) {
            this.dialogueContent.setVisible(true);
            onShow();
            return;
        }

        if (animationStyle === "fromBelow") {
            this.showUpFromBelow(onShow);
        } else {
            this.showUpFromSides(onShow);
        }
    },

    showUpFromSides: function (onShow) {
        const baseContentSize = this.background.baseContentSize;
        this.background.setContentSize(baseContentSize.width * 0.6, baseContentSize.height);
        this.content.setOpacity(0);
        if (this.textBgArrow) {
            this.textBgArrow.setVisible(false);
        }

        [this.leftPersonView, this.rightPersonView].filter(Boolean).forEach((person) => {
            const delay = person.isActive ? 0 : 0.25;

            person.setVisible(false);

            person.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.CallFunc(() => {
                    person.setPosition(person.hidePosition);
                }),
                new cc.Show(),
                new cc.MoveTo(0.35, person.showPosition).easing(cc.easeBackOut()),
                new cc.CallFunc(() => {
                    cleverapps.scenes.onAvoidNodeVisibilityChanged();
                })
            ));
        });

        this.background.runAction(new cc.Sequence(
            new cc.DelayTime(0.25),
            new Scale9SpriteResizeTo(0.25, baseContentSize)
        ));

        this.content.runAction(new cc.Sequence(
            new cc.DelayTime(0.25),
            new cc.FadeTo(0.25, 255)
        ));

        this.dialogueContent.runAction(new cc.Sequence(
            new cc.DelayTime(0.25),
            new cc.Show(),
            new cc.DelayTime(0.25),
            new cc.CallFunc(() => {
                onShow();
                if (this.textBgArrow) {
                    this.textBgArrow.setVisible(true);
                }
            })
        ));
    },

    showUpFromBelow: function (onShow) {
        const basePosition = this.content.getPosition();
        const startPosition = cc.p(basePosition.x, -basePosition.y - this.content.height);
        this.content.setAlignment(startPosition);
        this.content.runAction(new cc.MoveTo(0.375, basePosition).easing(cc.easeBackOut()));

        this.dialogueContent.runAction(new cc.Sequence(
            new cc.Show(),
            new cc.DelayTime(0.6),
            new cc.CallFunc(onShow)
        ));

        [this.leftPersonView, this.rightPersonView].filter(Boolean).forEach((person) => {
            const showPersonPosition = person.showPosition;
            person.setVisible(false);
            person.setPosition(showPersonPosition.x, -showPersonPosition.y - person.height);
            person.runAction(new cc.Sequence(
                new cc.DelayTime(person.isActive ? 0 : 0.05),
                new cc.Show(),
                new cc.MoveTo(0.45, showPersonPosition).easing(cc.easeBackOut(1)),
                new cc.CallFunc(() => {
                    cleverapps.scenes.onAvoidNodeVisibilityChanged();
                })
            ));
        });
    },

    updateActive: function (orientation) {
        const isLeft = orientation === "left";
        const active = isLeft ? this.leftPersonView : this.rightPersonView;
        const inactive = isLeft ? this.rightPersonView : this.leftPersonView;

        if (active) {
            if (active.updateActiveAction && !active.updateActiveAction.isDone()) {
                active.stopAction(active.updateActiveAction);
                delete active.updateActiveAction;
            }
            active.setActive(true);
            active.title.show();
            active.arrow.setVisible(true);
            const baseScale = this.getPersonScale(active);
            active.updateActiveAction = active.runAction(new cc.Spawn(
                new cc.TintTo(0.15, 255, 255, 255),
                new cc.ScaleTo(0.15, baseScale.x, baseScale.y)
            )).setFinalize(() => {
                active.setColor(cc.color(255, 255, 255));
                active.setScaleX(baseScale.x);
                active.setScaleY(baseScale.y);
            });
        }

        if (inactive) {
            if (inactive.updateActiveAction && !inactive.updateActiveAction.isDone()) {
                inactive.stopAction(inactive.updateActiveAction);
                delete inactive.updateActiveAction;
            }
            inactive.setActive(false);
            inactive.title.hide();
            inactive.arrow.setVisible(false);
            const baseScale = this.getPersonScale(inactive);
            inactive.updateActiveAction = inactive.runAction(new cc.Spawn(
                new cc.TintTo(0.15, 150, 150, 150),
                new cc.ScaleTo(0.15, baseScale.x * 0.95, baseScale.y * 0.95)
            )).setFinalize(() => {
                inactive.setColor(cc.color(150, 150, 150));
                inactive.setScaleX(baseScale.x * 0.95);
                inactive.setScaleY(baseScale.y * 0.95);
            });
        }
    },

    changeText: function (text, isWallAtRight) {
        const styles = cleverapps.styles.DialogueViewHorizontal;

        if (this.text) {
            this.text.removeFromParent();
        }
    
        cleverapps.effects.fire("ui.dialogue.next");

        this.text = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.DIALOGUE_MESSAGE_TEXT || cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT);
        this.text.initTextSize = this.text.getFontSize();
        this.content.addChild(this.text, 1);
        this.text.onResize = function () {
            const textStyles = styles.text;
            let padding = textStyles.padding;
            let alignment = cleverapps.UI.isRTL() ? cc.TEXT_ALIGNMENT_RIGHT : cc.TEXT_ALIGNMENT_LEFT;
            if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
                padding = textStyles.verticalPadding;
                alignment = cc.TEXT_ALIGNMENT_CENTER;
            }
            this.text.setHorizontalAlignment(alignment);
            let rightX = this.content.width - padding.fromWallX;
            let leftX = padding.x;
            if (isWallAtRight) {
                rightX = this.content.width - padding.x;
                leftX = padding.fromWallX;
            }
            const topY = this.content.height - padding.y;
            const bottomY = padding.y;

            let textScale = 1;
            let textWidth = rightX - leftX;
            let textHeight = topY - bottomY;

            if (textWidth > textStyles.optimization.width) {
                // text rendering optimization
                textScale = 1.5;
                textWidth /= textScale;
                textHeight /= textScale;
            }
            const maxFontSize = Math.round(this.text.initTextSize / textScale);
            this.text.setFontSize(maxFontSize);

            this.text.setDimensions(textWidth, 0);
            this.text.fitTo(undefined, textHeight);
            if (this.text.getFontSize() > maxFontSize) {
                this.text.setFontSize(maxFontSize);
            }
            this.text.setScale(textScale);
            this.text.setAnchorPoint(0.5, 1.0);
            this.text.setAlignment((leftX + rightX) / 2, topY);
            if (this.text._byLetterAnimationRunning) {
                this.text._byLetterAnimationDone();
                this.text.setString(text);
            }
        }.bind(this);
        this.text.onResize();
        this.text.byLetterAnimation({ callback: this.finishTyping.bind(this), speed: 0.005, startFrom: 50 });
    },

    onClose: function (silent, f) {
        this.byLetterAnimationFinish();
        this.hideImage();
        this.content.stopAllActions();

        if (silent) {
            f();
            return;
        }
        const animationStyle = cleverapps.styles.DialogueViewHorizontal.showAnimation;
        if (animationStyle === "fromBelow") {
            this.closeToBelow(f);
        } else {
            this.closeToSides(f);
        }
    },

    closeToSides: function (onClose) {
        if (this.text) {
            this.text.removeFromParent();
        }
        [this.leftPersonView, this.rightPersonView].filter(Boolean).forEach((person) => {
            const delay = person.isActive ? 0.25 : 0;

            person.arrow.setVisible(false);
            person.title.setVisible(false);

            person.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.MoveTo(0.25, person.hidePosition)
            ));
        });

        this.background.runAction(new cc.Spawn(
            new cc.FadeTo(0.5, 0),
            new Scale9SpriteResizeTo(0.5, this.background.width * 0.6, this.background.height)
        ));

        this.dialogueContent.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.CallFunc(onClose)
        ));
    },

    closeToBelow: function (onClose) {
        this.content.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.MoveTo(0.225, this.content.x, -this.content.y - this.content.height).easing(cc.easeBackIn()),
            new cc.CallFunc(onClose),
            new cc.RemoveSelf()
        ));
        [this.leftPersonView, this.rightPersonView].filter(Boolean).forEach((person) => {
            person.runAction(new cc.Sequence(
                new cc.MoveTo(0.1875, person.x, -person.y - person.height).easing(cc.easeBackIn(0.6)),
                new cc.Hide()
            ));
        });
    },

    byLetterAnimationFinish: function () {
        if (this.text) {
            this.text.byLetterAnimationFinish();
        }
    },

    addImage: function (asset) {
        const bundle = bundles[this.dialogue.imageBundle];
        let node;

        if (bundle.frames[asset]) {
            node = new cc.Sprite(bundle.frames[asset]);
        } else if (bundle.jsons[asset]) {
            node = new cleverapps.Spine(bundles[this.dialogue.imageBundle].jsons[asset]);
            node.setAnimation(0, "animation", false);
        } else {
            return;
        }

        if (bundles.dialogues.frames.dialogue_image_bg_png) {
            this.image = cleverapps.UI.createScale9Sprite(bundles.dialogues.frames.dialogue_image_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
            this.imageNode = node;
            this.image.addChild(node);
        } else {
            this.image = node;
        }

        this.createImageBubbles();

        this.addChild(this.image);
        this.updateImagePosition();
    },

    createImageBubbles: function () {
        const styles = cleverapps.styles.DialogueViewHorizontal.image.bubbles;
        this.imageBubbles = new cc.Node();
        this.imageBubbles.bubbleItems = [];

        styles.items.forEach(function (item) {
            const bubble = new cc.Sprite(bundles.dialogues.frames.dialogue_bubble_png);
            bubble.setScale(item.scale);
            bubble.setAnchorPoint(0.5, 0.5);
            this.imageBubbles.addChild(bubble);
            this.imageBubbles.bubbleItems.push(bubble);
        }, this);

        this.addChild(this.imageBubbles);
    },

    updateImagePosition: function () {
        if (!this.image) {
            return;
        }

        const styles = cleverapps.styles.DialogueViewHorizontal.image;
        const isLeftActive = this.leftPersonView && this.leftPersonView.isActive;
        const activePerson = isLeftActive ? this.leftPersonView : this.rightPersonView;

        if (this.imageNode) {
            const bubbleSize = styles.size[cleverapps.resolution.mode];
            cleverapps.UI.fitToBox(this.imageNode, {
                width: bubbleSize.width - styles.padding * 2,
                height: bubbleSize.height - styles.padding * 2
            });
            this.image.setContentSize2(bubbleSize.width, bubbleSize.height);
            this.imageNode.setAlignment({ align: "center" }, { align: "center" });
        }

        this.placeImage(activePerson, isLeftActive);
        this.placeBubbles(activePerson, isLeftActive);
    },

    placeImage: function (activePerson, isLeftActive) {
        const styles = cleverapps.styles.DialogueViewHorizontal.image;
        const personSceneBox = activePerson.getGlobalBoundingBox();
        const sceneSize = cleverapps.resolution.getSceneSize();
        const imageHalfWidth = this.image.width / 2;
        const imageHalfHeight = this.image.height / 2;

        let imageCenterSceneX;

        const minPersonCenterOffset = Math.max(personSceneBox.width / 2 + styles.bubbleOffsetX, styles.minPersonCenterOffsetX);
        if (isLeftActive) {
            imageCenterSceneX = Math.min(personSceneBox.x + personSceneBox.width / 2 + minPersonCenterOffset + imageHalfWidth, sceneSize.width / 2);
        } else {
            imageCenterSceneX = Math.max(personSceneBox.x + personSceneBox.width / 2 - minPersonCenterOffset - imageHalfWidth, sceneSize.width / 2);
        }

        let imageCenterSceneY = personSceneBox.y + personSceneBox.height + styles.bubbles.personOffsetY;
        if (imageCenterSceneY + imageHalfHeight > sceneSize.height) {
            imageCenterSceneY = sceneSize.height - imageHalfHeight - (styles.topPadding || 20);
        }

        this.image.setAnchorPoint(0.5, 0.5);
        this.image.setAlignment(this.convertToNodeSpace(cc.p(imageCenterSceneX, imageCenterSceneY)));
    },

    placeBubbles: function (activePerson, isLeftActive) {
        if (!this.imageBubbles) {
            return;
        }

        const styles = cleverapps.styles.DialogueViewHorizontal.image;
        const personSceneBox = activePerson.getGlobalBoundingBox();
        const imageBox = this.image.getGlobalBoundingBox();

        const imageEdgeScene = cc.p(
            isLeftActive ? imageBox.x - styles.bubbleOffsetX : imageBox.x + imageBox.width + styles.bubbleOffsetX,
            imageBox.y + imageBox.height / 2
        );
        const personHeadScene = cc.p(
            personSceneBox.x + personSceneBox.width / 2,
            personSceneBox.y + personSceneBox.height * 0.85
        );
        const controlScene = cc.p(
            (imageEdgeScene.x + personHeadScene.x) / 2,
            (imageEdgeScene.y + personHeadScene.y) / 2 + styles.bubbles.arcHeight
        );

        const bezier = function (t, a, c, b) {
            return (1 - t) * (1 - t) * a + 2 * (1 - t) * t * c + t * t * b;
        };

        styles.bubbles.trailT.forEach(function (t, i) {
            const trailScene = cc.p(
                bezier(t, imageEdgeScene.x, controlScene.x, personHeadScene.x),
                bezier(t, imageEdgeScene.y, controlScene.y, personHeadScene.y)
            );
            this.imageBubbles.bubbleItems[i].setPosition(this.imageBubbles.convertToNodeSpace(trailScene));
        }, this);
    },

    hideImage: function () {
        if (this.image) {
            this.image.removeFromParent();
            delete this.image;
            delete this.imageNode;
        }
        if (this.imageBubbles) {
            this.imageBubbles.removeFromParent();
            delete this.imageBubbles;
        }
    }

});

cleverapps.styles.DialogueViewHorizontal = {
    position: {
        x: { align: "left", dx: 0 },
        y: { align: "center", dy: 0 }
    },
    size: [
        { height: 240 },
        { height: 280 },
        { height: 280 }
    ],
    widthPadding: 0,
    offsetY: 20,
    showAnimation: "fromSides",

    arrow: {
        y: { align: "top", dy: 23 }
    },

    text: {
        padding: {
            fromWallX: 30,
            x: 30,
            y: 30
        },
        verticalPadding: {
            fromWallX: 50,
            x: 50,
            y: 40
        },

        optimization: {
            width: 1000
        }
    },

    persons: {
        mobileScale: 0.65,
        squareScale: 0.8,

        margin: 100,
        offsetY: -450
    },

    title: {
        offsetX: 0,
        y: { align: "top", anchor: false, dy: 0 },
        mobileY: { align: "top", anchor: false, dy: 0 }
    },

    image: {
        padding: 20,
        minPersonCenterOffsetX: 300,
        bubbleOffsetX: 20,
        size: [
            { width: 450, height: 300 },
            { width: 510, height: 340 },
            { width: 600, height: 400 }
        ],

        bubbles: {
            personOffsetY: 100,
            arcHeight: 120,
            trailT: [0.25, 0.55, 0.7],
            items: [
                { scale: 1 },
                { scale: 0.4 },
                { scale: 0.25 }
            ]
        }

    }
};

cleverapps.styles.DialogueViewHorizontal.persons[Person.ORIENTATION_LEFT] = [
    { x: { align: "left", dx: 20 } },
    { x: { align: "left", dx: 75 } },
    { x: { align: "left", dx: 75 } }
];

cleverapps.styles.DialogueViewHorizontal.persons[Person.ORIENTATION_RIGHT] = [
    { x: { align: "right", dx: -20 } },
    { x: { align: "right", dx: -75 } },
    { x: { align: "right", dx: -75 } }
];